module.exports = __webpack_public_path__ + "static/media/manage_speakers.759053fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/components/manage_speakers.svg
// module id = 1812
// module chunks = 0